import {
    Injectable
} from '@angular/core';

import {
    NgbModal
} from '@ng-bootstrap/ng-bootstrap';

import { StudyAuditReportComponent } from './study-audit-report.component';

/*
* Service to view the study audit-report modal.
*/
@Injectable()
export class ViewStudyAuditReportComponentService {

    constructor(
        private modalService: NgbModal
    ) {
        //
    }

    openComponent(studyKey: number) {
        const modalRef = this.modalService.open(StudyAuditReportComponent, { size: 'lg' });
        modalRef.componentInstance.studyKey = studyKey;
    }
}
